// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"d6f5ef03","386":"4b93fe0a","749":"f7654542"}[chunkId] + ".chunk.js";
};